import { initializeApp, type FirebaseOptions } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup, type AuthProvider } from "firebase/auth";
import { getStorage, ref } from "firebase/storage";

import { type AuthSSOProvider } from "../types/user";

//? Config
const firebaseConfig: FirebaseOptions = {
   apiKey: import.meta.env.VITE_PUBLIC_FIREBASE_API_KEY,
   authDomain: import.meta.env.VITE_PUBLIC_FIREBASE_AUTH_DOMAIN,
   projectId: import.meta.env.VITE_PUBLIC_FIREBASE_PROJECT_ID,
   storageBucket: import.meta.env.VITE_PUBLIC_FIREBASE_STORAGE_BUCKET,
   messagingSenderId: import.meta.env.VITE_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
   appId: import.meta.env.VITE_PUBLIC_FIREBASE_APP_ID,
};

//? Apps
export const app = initializeApp(firebaseConfig, "main");

//? Auth API
export const auth = getAuth(app);
export const googleAuthProvider = new GoogleAuthProvider();

//? Storage API
export const storage = getStorage(app, `gs://${firebaseConfig.storageBucket}`);
export const storageUserProfileImageRef = ref(storage, "/users/profileImages");

//? Functions
const providers: Record<AuthSSOProvider, AuthProvider> = {
   google: googleAuthProvider,
};

export const signInWithPopupProvider = (provider: AuthSSOProvider) => {
   return signInWithPopup(auth, providers[provider]);
};
